// src/layout/AppLayout/DrawerContent.js
import React from 'react';
import { Divider, Box, Button, useTheme } from '@mui/material';
import { WbSunny as SunIcon, NightsStay as MoonIcon } from '@mui/icons-material';
import AppLogo from './AppLogo';
import NavigationMenu from './NavigationMenu';
import AppVersion from './AppVersion';
import { useThemeToggle } from '../../context/ThemeContext';

// Component for the sidebar drawer content
const DrawerContent = ({ onItemClick }) => {
  const { mode, toggleTheme } = useThemeToggle();
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <AppLogo />
      <Divider sx={{ mb: 2, borderColor: theme.palette.outlineVariant }} />
      
      <NavigationMenu onItemClick={onItemClick} />
      
      {/* Theme Toggler Option */}
      <Box sx={{ px: 2, py: 2, mt: 'auto' }}>
        <Button
          fullWidth
          variant="outlined"
          onClick={toggleTheme}
          startIcon={mode === 'dark' ? <SunIcon /> : <MoonIcon />}
          sx={{
            py: 1.2,
            borderRadius: '9999px',
            borderColor: theme.palette.outline,
            color: theme.palette.text.primary,
            fontSize: '0.875rem',
            fontWeight: 600,
            textTransform: 'none',
            justifyContent: 'center',
            px: 3,
            transition: 'all 0.2s cubic-bezier(0.2, 0, 0, 1)',
            '&:hover': {
              borderColor: theme.palette.primary.main,
              backgroundColor: theme.palette.surfaceContainerHigh,
            },
            '& .MuiButton-startIcon': {
              color: mode === 'dark' ? '#fbbf24' : '#6366f1', // warm gold sun or calm indigo moon
            }
          }}
        >
          {mode === 'dark' ? 'Light Mode' : 'Dark Mode'}
        </Button>
      </Box>
      
      <Divider sx={{ borderColor: theme.palette.outlineVariant }} />
      <AppVersion />
    </Box>
  );
};

export default DrawerContent;